import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';

export function useGetItilCategoriesService(
  tokenUserGLPI,
  tokenAppGLPI,
  glpiUrl,
) {
  const [itilCategories, setItilCategories] = React.useState();
  const [loadingCategory, setLoadingCategory] = React.useState();
  const [errorCategory, setErrorCategory] = React.useState();
  const { httpGet } = Sebrae.useHttp({
    headers: {
      Authorization: `user_token ${tokenUserGLPI}`,
      'App-Token': tokenAppGLPI,
    },
  });

  React.useEffect(() => {
    setItilCategories();
    setLoadingCategory(true);
    setErrorCategory(false);

    httpGet(`${glpiUrl}/apirest.php/initSession`)
      .then((resp) => {
        setItilCategories({
          headers: {
            'Session-Token': resp?.session_token,
            'App-Token': tokenAppGLPI,
          },
        });
      })
      .catch(() => setErrorCategory(true))
      .finally(() => setLoadingCategory(false));
  }, [glpiUrl, httpGet, tokenAppGLPI]);

  return { itilCategories, loadingCategory, errorCategory };
}
